﻿import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logoutUser } from "../redux/state/loginstate/user";
import { persistor } from "../redux/store";
import { STORAGE_SESSION_ACTIVE } from "../utils/storageKeys";

/* El token solo vive en memoria (no se persiste por seguridad), así que al
   recargar la página se pierde. Cuando eso pasa, se fuerza un cierre de
   sesión completo (igual que "cerrar sesión" manual) antes de redirigir al
   login, para no dejar datos de la sesión anterior en el navegador. */
const useRequireToken = (token, redirecTo = "/") => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (!token) {
      const wasActive = localStorage.getItem(STORAGE_SESSION_ACTIVE) === "true";
      dispatch(logoutUser());
      persistor.purge();
      sessionStorage.removeItem("expiretime");
      localStorage.removeItem(STORAGE_SESSION_ACTIVE);
      const target = wasActive ? `${redirecTo}?razon=expirada` : redirecTo;
      navigate(target, { replace: true });
    }
  }, [token, redirecTo, dispatch, navigate]);
};

export default useRequireToken;
